/**
 * Redondeo monetario ARS: half-up a 2 decimales (por línea / monto).
 */
export function roundArsHalfUp(value: number): number {
  if (!Number.isFinite(value)) return 0;
  const sign = value < 0 ? -1 : 1;
  const abs = Math.abs(value);
  const scaled = abs * 100;
  const rounded = Math.floor(scaled + 0.5);
  return (sign * rounded) / 100;
}
